export default __webpack_public_path__ + "static/media/trackinfo_racingline.bb52369c.avif";